import { FLOATING_ELEMENT_PLACEMENT } from '../../../constants/common'

export const PROFILE_USER_INFO_ITEM_OPEN_DELAY_MS = 200

export const PROFILE_USER_INFO_ITEM_CLOSE_DELAY_MS = 100

export const PROFILE_USER_INFO_ITEM_TOOLTIP_PROPS = {
  hoverConfig: {
    enabled: false,
  },
  placement: FLOATING_ELEMENT_PLACEMENT.top,
}

export const PROFILE_USER_INFO_ITEM_CONTACT_LABEL_KEY = {
  additionalEmail: 'RequestProfile.WidgetUserCardAdditionalEmailLabelKey',
  additionalTelephone:
    'RequestProfile.WidgetUserCardAdditionalTelephoneLabelKey',
  mainEmail: 'RequestProfile.WidgetUserCardMainEmailLabelKey',
  mainTelephone: 'RequestProfile.WidgetUserCardMainTelephoneLabelKey',
  personalStatus: 'RequestProfile.WidgetUserCardPersonalStatusLabelKey',
  website: 'RequestProfile.WidgetUserCardWebsiteLabelKey',
}

export const PROFILE_USER_INFO_ITEM_TOOLTIP_CONTACT_TYPE = {
  authEmail: 'auth_email',
  authPhone: 'auth_phone',
  email: 'email',
  phone: 'phone',
  website: 'website',
}
